import { changeRoundStateAction } from 'core/widgets/RoundStates/actions';
import { put, select } from 'redux-saga/effects';
import { Notifications } from 'types';
import { saveWinnerToStoreAction } from 'core/widgets/Winner/actions';
import { updateBallsCounterAction } from 'core/widgets/Scoreboard/BallsCounter/actions';
import { addScoreboardItemAction } from 'core/widgets/Scoreboard/Boards/actions';
import { clearAllBetsAction } from 'core/widgets/Bet/actions';
import { confirmedBetSelector } from 'core/widgets/Bet';
import { BetType } from 'core/widgets/Bet/types';
import { resetRepeatBetAction, saveRoundBetAction } from 'core/widgets/BetRepeat/actions';
import { resetDoubleBetAction } from 'core/widgets/BetDouble/actions';
import { setTotalBetAction } from 'core/widgets/User/actions';
import { RoundStates } from '../../RoundStates/types';
import { OnResultConfirmedData } from '../../Winner/types';

export function* onResultConfirmedSaga({
  type: notificationType,
  data: result,
}: OnResultConfirmedData) {
  if (notificationType === Notifications.RESULT_CONFIRMED) {
    const { winner, playerPair, bankerPair } = result;
    const confirmedBets: BetType = yield select(confirmedBetSelector);

    yield put(setTotalBetAction(0));
    yield put(saveRoundBetAction(confirmedBets));
    yield put(resetDoubleBetAction());
    yield put(resetRepeatBetAction());
    yield put(saveWinnerToStoreAction({ winner }));
    yield put(changeRoundStateAction({ roundState: RoundStates.ResultConfirmed }));
    yield put(updateBallsCounterAction({ winner }));
    yield put(addScoreboardItemAction({ item: { winner, playerPair, bankerPair } }));
    yield put(clearAllBetsAction());
  }
}
